import { connect } from "react-redux";
import BankSheetList from "./BankSheetList";
import { bindActionCreators } from "redux";
import {
    payoutConfigurationListRequest, payoutConfigurationVerifyRequest
} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    payoutConfigurationListResponse : state.CarLoan.payoutConfigurationListResponse,
    payoutConfigurationVerifyResponse : state.CarLoan.payoutConfigurationVerifyResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        payoutConfigurationListRequest,
        payoutConfigurationVerifyRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BankSheetList);